export default __webpack_public_path__ + "static/media/light-app-preview.e0dfe078.png";